import * as actions from './redux/actions';

import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class PaymentRightSideBar extends Component {
	static propTypes = {
		pbServiceList: PropTypes.object,
		home: PropTypes.object,
		actions: PropTypes.object,
		walletMoneyAdded: PropTypes.func,
		virtualMoneyAmount: PropTypes.func,
		basicFare: PropTypes.func,
		calculateNetFare: PropTypes.func,
		calculateNetFareUSD: PropTypes.func,
	};

	countrieCodes = [];
	paymentGatewayList;
	idCardTypes = [];

	constructor(props) {
		super(props);
		this.state = {
			mobileError: null,
			emailError: null,
			confirmEmailError: null,
			selectedPaymentGateway: null,
			showBookingConfirmModal: false,
			wallet: false,
			walletMoney: 0,
			confirmTabSelected: 1,
		};
		console.log('@@@@', this.props.operator);
	}

	componentDidUpdate() {
		for (let c of this.props.home.metaData.country_codes) {
			this.countrieCodes.push({
				id: c,
				name: '+' + c,
			});
		}
		this.paymentGatewayList = CommonService.copyObject(
			this.props.home.metaData.payment_gate_way_list_v1,
		);
	}

	renderSummaryDetailsCard = (service, date, source, dest, title) => {
		return (
			<div className="summary-details">
				<div className="journey-date flex-row">
					<div className="kupos-button-secondary">{title}</div>
					<span className="date">
						{date
							? DateService.getDayNameFromDate(date) +
							', ' +
							DateService.getDateFromDate(date) +
							' ' +
							DateService.getMonthNameFromDate(date)
							: ''}
					</span>
				</div>
				<div className="op-name">{service.route ? service.route.operator_service_name : ''}</div>
				<div className="location-details">
					<div className="city-name">
						<img
							className="icon-source"
							src="/static/images/icons/home/icon_source.png"
							alt={this.props.t('TRANSLATIONS.ICON_SOURCE')}
						/>
						<span>{source ? source.label : ''}</span>
					</div>
					<div className="address">
						{service.boardingStage
							? service.boardingStage.landmark +
							' - ' +
							DateService.ampm(service.boardingStage.time)
							: ''}
					</div>
				</div>
				<div className="location-details">
					<div className="city-name">
						<img className="icon-source" src="/static/images/icons/home/icon_source2.png" />
						<span>{dest ? dest.label : ''}</span>
					</div>
					<div className="address">
						{service.droppingStage
							? service.droppingStage.landmark +
							' - ' +
							DateService.ampm(service.droppingStage.time)
							: ''}
					</div>
				</div>
			</div>
		);
	};

	render() {
		let selectedServiceOnward =
			this.props.pbServiceList && this.props.pbServiceList.selectedServiceOnward
				? this.props.pbServiceList.selectedServiceOnward
				: {};
		let onwardPBDate = this.props.home ? this.props.home.onwardPBDate : null;
		let destCityOnward = this.props.home ? this.props.home.pbDestinationCity : null;
		let sourceCityOnward = this.props.home ? this.props.home.pbSourceCity : null;

		let selectedServiceReturn =
			this.props.pbServiceList && this.props.pbServiceList.selectedServiceReturn
				? this.props.pbServiceList.selectedServiceReturn
				: {};
		let returnPBDate = this.props.home ? this.props.home.returnPBDate : null;
		let sourceCityReturn = this.props.home ? this.props.home.pbDestinationCity : null;
		let destCityReturn = this.props.home ? this.props.home.pbSourceCity : null;

		console.log('stateis', this.props.operator);

		return (
			<div className="pb-service-list-payment-right-side-bar journey-summary-sidebar">
				<div className="kupos-card">
					<div className="summary-title">Summary</div>
					{this.renderSummaryDetailsCard(
						selectedServiceOnward,
						onwardPBDate,
						sourceCityOnward,
						destCityOnward,
						'Going',
					)}
					{returnPBDate
						? this.renderSummaryDetailsCard(
							selectedServiceReturn,
							returnPBDate,
							sourceCityReturn,
							destCityReturn,
							'Return',
						)
						: null}
				</div>

				<div className="kupos-card payment-details-sidebar">
					<div className="payment-sidebar-title">
						Payment <span className="bold">details</span>
					</div>
					<div className="payment-seats">
						<div>Seats:</div>
						{this.props.pbServiceList &&
							this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
							? this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook.map(
								(val, key) => {
									return (
										<div key={key} className="payment-seat-row flex-row">
											<div>
												<span className="bold">{val.number},</span>{' '}
												{CommonService.capitalize(val.type)}:
											</div>
											<div>${val.net_amount}</div>
										</div>
									);
								},
							)
							: null}
						{this.props.pbServiceList &&
							this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
							? this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook.map(
								(val, key) => {
									return (
										<div key={key} className="payment-seat-row flex-row">
											<div>
												<span className="bold">{val.number},</span>{' '}
												{CommonService.capitalize(val.type)}:
											</div>
											<div>${val.net_amount}</div>
										</div>
									);
								},
							)
							: null}
					</div>
					<div className="discount-block fl">
						<div className="discount-row flex-row">
							<div>Discount:</div>
							<div className="secondary-text">
								{this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward
									? this.props.pbServiceList.bookingDetailsOnward.discountAmount
									: ''}
							</div>
						</div>
						<div className="discount-row flex-row">
							<div>Promo code:</div>
							<div className="secondary-text">-1,000</div>
						</div>
						<div className="promocode font10">Caja Los Hereos</div>
					</div>
					<div className="subtotal-block">
						<div className="subtotal-row flex-row">
							<div className="primary-text">Subtotal:</div>
							<div className="primary-text bold">
								$
								{(this.props.pbServiceList && this.props.pbServiceList.bookingDetailsOnward
									? this.props.pbServiceList.bookingDetailsOnward.totalBookingAmount
									: 0) +
									(this.props.pbServiceList && this.props.pbServiceList.bookingDetailsReturn
										? this.props.pbServiceList.bookingDetailsReturn.totalBookingAmount
										: 0)}
							</div>
						</div>
						<div className="subtotal-row flex-row">
							<div className="primary-text">Amount in USD:</div>
							<div className="primary-text bold">${this.props.calculateNetFareUSD()}</div>
						</div>
					</div>
				</div>

				<div
					className="total bold"
					style={{
						background: this.props.operator.show_top_header
							? (this.props.operator.color_codes ? this.props.operator.color_codes.secondary_color : '')
							: '',
					}}
				>
					<div className="total-row flex-row">
						<div>Total</div>
						<div>${this.props.calculateNetFare()}</div>
					</div>
				</div>
			</div>
		);
	}
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		pbServiceList: state.pbServiceList,
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRightSideBar);



// WEBPACK FOOTER //
// ./src/features/pb-service-list/PaymentRightSideBar.js